import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/Index'),
      meta: {
        requiresAuth: true
      },
      children: [
        // Dashboard
        {
          name: 'ProjectsViewer',
          path: '',
          component: () => import('@/views/mainView/ProjectsViewer'),
        },
        {
          name: 'ProjectDetails',
          path: '/details',
          component: () => import('@/views/detailsView/ProjectDetails'),
        },
        {
          name: 'ProjectDetails',
          path: '/details/:id',
          component: () => import('@/views/detailsView/ProjectDetails'),
        },
        {
          name: 'AdminUsers',
          path: '/users',
          component: () => import('@/views/adminView/AdminUsers'),
          
          children: [
            {
              name:'UsersList',
              path: '',
              component: ()=>import('@/views/adminView/components/UsersList'),
            },
            {
              name:'CreateUser',
              path: '/users/create',
              component: ()=>import('@/views/adminView/components/CreateUser'),
            },
            {
              name:'UpdateUser',
              path: '/users/update',
              component: ()=>import('@/views/adminView/components/CreateUser'),
            }
          ]
        },
        {
          name: 'History',
          path: '/history',
          component: () => import('@/views/historyView/History'),
          children: [
            {
              name:'OwnHistory',
              path: '',
              component: ()=>import('@/views/historyView/components/OwnHistory'),
            },
            {
              name:'ProjectsHistory',
              path: '/history/projects',
              component: ()=>import('@/views/historyView/components/ProjectsHistory')
            }
          ]
        },
        {
          name: 'AdminOrganism',
          path: '/organism',
          component: () => import('@/views/organismsView/AdminOrganism'),
          children: [
            {
              name:'OrganismList',
              path: '',
              component: ()=>import('@/views/organismsView/components/OrganismList')
            },
            {
              name:'CreateOrganism',
              path: '/organism/create',
              component: ()=>import('@/views/organismsView/components/CreateOrganism'),
            }
          ]
        },
        {
          name: 'AdminStatistics',
          path: '/statistics',
          component: () => import('@/views/statisticsView/AdminStatistics'),
          children: [
            {
              name:'Statistics',
              path: '',
              component: ()=>import('@/views/statisticsView/components/Statistics')
            },
          ]
        }
      ]
    },
    {
      path: '/redirect',
      component: () => import('@/views/splashScreen/SplashScreen'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/callback',
      component: () => import('@/views/Callback'),
    },
    { path: '*', redirect: '/' }
  ]
});
export default router

